/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningCircleIcon32Regular = forwardRef('WarningCircleIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M17.25 22a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z" }),
        React.createElement("path", { d: "M17 10a1 1 0 1 0-2 0v7.5a1 1 0 1 0 2 0V10Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 16C3 8.82 8.82 3 16 3s13 5.82 13 13-5.82 13-13 13S3 23.18 3 16ZM16 5C9.925 5 5 9.925 5 16s4.925 11 11 11 11-4.925 11-11S22.075 5 16 5Z" })));
});
